import {ChevronDown} from "lucide-react";
import {useMemo, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {getVeryParentId} from "../commonmethod/CommonMethod";
import {getTopMenuIcon} from "../../layouts/topMenuIcons";

const MOBILE_HIDDEN_TOP_MENU_NAMES = new Set(["환경설정"]);

function filterMobileTopMenus(menus, depth) {
    if (depth !== 0 || !Array.isArray(menus)) {
        return menus ?? [];
    }
    return menus.filter((menu) => !MOBILE_HIDDEN_TOP_MENU_NAMES.has(menu.name));
}

export function MobileMenu({data, depth = 0, setOpenMenu, setClicked}) {
    const [expandedId, setExpandedId] = useState(null);
    const location = useLocation();
    const menus = useMemo(() => filterMobileTopMenus(data, depth), [data, depth]);

    const toggleSubMenu = (menuId) => {
        setExpandedId((prev) => (prev === menuId ? null : menuId));
    };

    const setTitle = (menu) => {
        const totalMenu = JSON.parse(localStorage.getItem("menus"));
        const veryParent = getVeryParentId(totalMenu, menu);
        localStorage.setItem("topMenuId", veryParent);
        setClicked(parseInt(veryParent));
    };

    const isActive = (url) =>
        !!url && (location.pathname === url || location.pathname.startsWith(`${url}/`));

    const isTop = depth === 0;
    const rowClass = isTop ? "mobile-nav-top" : "mobile-nav-sub";

    return (
        <ul className={isTop ? "mobile-nav-list" : "mobile-nav-sublist"}>
            {menus.map((menu) => {
                const hasChildren = menu.children && menu.children.length > 0;
                const expanded = expandedId === menu.id;

                return (
                    <li key={menu.id}>
                        {menu.url ? (
                            <Link
                                to={menu.url}
                                onClick={() => {
                                    setOpenMenu(false);
                                    setTitle(menu);
                                }}
                                className={`${rowClass} ${isActive(menu.url) ? "is-active" : ""}`}
                            >
                                {isTop && (
                                    <span className="mobile-nav-ico">{getTopMenuIcon(menu.icon)}</span>
                                )}
                                <span className="mobile-nav-label">{menu.name}</span>
                            </Link>
                        ) : (
                            <button
                                type="button"
                                onClick={() => toggleSubMenu(menu.id)}
                                className={`${rowClass} ${expanded ? "is-open" : ""}`}
                            >
                                {isTop && (
                                    <span className="mobile-nav-ico">{getTopMenuIcon(menu.icon)}</span>
                                )}
                                <span className="mobile-nav-label">{menu.name}</span>
                                {hasChildren && (
                                    <ChevronDown
                                        size={18}
                                        className={`mobile-nav-caret ${expanded ? "is-rot" : ""}`}
                                    />
                                )}
                            </button>
                        )}

                        {expanded && hasChildren && (
                            <MobileMenu
                                data={menu.children}
                                depth={depth + 1}
                                setOpenMenu={setOpenMenu}
                                setClicked={setClicked}
                            />
                        )}
                    </li>
                );
            })}
        </ul>
    );
}
